import axios from "axios";
import { AUTH_TOKEN, REACT_APP_PAM_API } from "../constants";

// Where an organisation's SSH recordings are kept (local volume, S3, GCS).
// Backend: internal/pam/handler/recordingstorage/handler.go. Every call is
// administrator-only (403 {error: "administrator role required"}) and the
// organisation comes from the session, never the body — so no orgId here.
//
// Each helper resolves to the response body and rejects with the axios error;
// use recordingStorageError(err) for the message to show.
const headers = () => ({
  headers: { "X-Authorization": AUTH_TOKEN(), withCredentials: true },
});

const post = (path, payload = {}) =>
  axios.post(`${REACT_APP_PAM_API}/recordingStorage/${path}`, payload, headers()).then((res) => res?.data);

// → { config: { provider, bucket, region, endpoint, prefix, pathStyle, sse,
//               kmsKeyId, credentialMode, hasCredential, revision, updatedAt,
//               lastTestAt, lastTestOk, lastTestError },
//     recordings: { local, pending, failing, held, remote } | null }
// Empty strings / false are omitted from config (omitempty). recordings is null
// when the counts query failed.
export const getRecordingStorage = () => post("get", {});

// body: { provider, bucket, region, endpoint, prefix, pathStyle, sse, kmsKeyId,
//         credentialMode, credentials: {...} | null, backfill }
// 200 → { config, test: {ok, error, deleteAllowed, warning} | null, backfilled }
// 400 → { error }           validation (nothing saved)
// 422 → { error, test? }    the bucket test failed (nothing saved)
export const setRecordingStorage = (body) => post("set", body);

// Tests the SAVED configuration. Always 200 → { test, message? }; test.ok false
// carries test.error.
export const testRecordingStorage = () => post("test", {});

// Re-queues every held recording ({} = all). → { released }
export const retryHeldRecordings = () => post("retryHeld", {});

export const recordingStorageError = (err, fallback = "Request failed") => {
  const data = err?.response?.data;
  if (data && typeof data.error === "string" && data.error) return data.error;
  if (err?.response?.status === 403) return "Administrator role required";
  if (err?.response?.status === 401) return "Your session has expired — sign in again";
  return err?.message || fallback;
};
